import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		background: THEME.colors.background.light,
		borderRadius: THEME.common.borderRadius,
		padding: THEME.spacing.lg,
		boxShadow: `0 1px 3px ${THEME.colors.border.main}`,
		gridColumn: 'span 6 !important',
	},
	title: {
		fontSize: 18,
		fontWeight: 600,
		marginBottom: THEME.spacing.md,
		color: THEME.colors.text.main,
	},
	loading: {
		padding: THEME.spacing.xl,
		textAlign: 'center',
		color: THEME.colors.text.light,
	},
	empty: {
		padding: THEME.spacing.xl,
		textAlign: 'center',
		color: THEME.colors.text.light,
	},
	tooltip: {
		background: THEME.colors.background.light,
		border: `1px solid ${THEME.colors.border.main}`,
		borderRadius: 4,
		padding: THEME.spacing.sm,
		boxShadow: `0 2px 8px rgba(0, 0, 0, 0.15)`,
		position: 'relative',
		zIndex: 1000,
		pointerEvents: 'none',
	},
	tooltipLabel: {
		fontWeight: 600,
		marginBottom: THEME.spacing.xs,
		color: THEME.colors.text.main,
		fontSize: 14,
	},
	tooltipValue: {
		margin: 0,
		color: THEME.colors.text.light,
		fontSize: 12,
	},
});
